var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",attrs:{"method":_vm.method,"disabled":_vm.processing},on:_vm._d({},[_vm.trigger,function($event){$event.preventDefault();return _vm.request($event)}])},[_vm._t("default",null,null,this)],2)}
var staticRenderFns = []

export { render, staticRenderFns }